import { createSelector } from 'reselect';

const getDashboards = state => state.masterData.dashboards;

export const getStarredDashboards = createSelector(
  [getDashboards],
  (dashboards) => {
    return (dashboards && dashboards.length) ?
      dashboards.filter(dashboard => dashboard.isStarred) : [];
  },
);
